<div class="relative mt-20 flex w-[400px] flex-col items-center gap-4 rounded-xl bg-background-card p-6 shadow-modal">
  <p class="typo-h4-medium text-center text-text-primary">{{ 'perio_exam_feature_flag_disabled_modal_title' | translate }}</p>
  <p class="typo-h5-book text-center text-text-secondary">{{ 'perio_exam_feature_flag_disabled_modal_body' | translate }}</p>
  <button class="typo-h4-semibold btn-primary mt-4 block h-[40px] text-text-white" (click)="onOkButtonClicked()">
    {{ 'perio_exam_feature_flag_disabled_modal_button_label' | translate }}
  </button>
</div>
